'use client'

import { useEffect } from 'react'
import { useShowRestModals } from './useShowRestModals'
import { useInitialServices } from './useInitialServices'
import type { IAuthUser, IProfileUser } from '../../../../interfaces/src'

interface UseLoadInitialServicesAndModalsProps {
  profile: IProfileUser
  authUser: IAuthUser
}

export const useLoadInitialServicesAndModals = ({
  authUser,
  profile
}: UseLoadInitialServicesAndModalsProps) => {
  // const [isGrowthbookSet, setIsGrowthbookSet] = useState(false)
  const { handleShowRestModals } = useShowRestModals({
    termsAndConditions: profile?.termsAndConditions,
    profile,
    authUser
  })

  useInitialServices({
    profile,
    authUser
  })

  const handleShowModals = () => {
    handleShowRestModals()
  }

  useEffect(() => {
    handleShowModals()
  }, [])
}
